import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataLoadState: 0, //0 - not loaded, 1 - is loading, 2 - loaded, 3 - error
  dataLoadError: null,
  initialData: null,
  data: null,
  cart: [],
   productsByCategory: {}
};

export const winesSlice = createSlice({
  name: "wines",
  initialState,
  reducers: {
    setCategoryProducts: (state, action) => {
  const { cat_id, products } = action.payload;
  state.productsByCategory[cat_id] = products;
},

    updateLoadState: (state, action) => {
      state.dataLoadState = action.payload.state;
      state.dataLoadError = action.payload.error;
    },

    updateData: (state, action) => {
      state.initialData = action.payload;
      state.data = action.payload;
    },

    /*addItemToCart: (state, action) => {
      state.cart.push(action.payload);
    }*/
   addItemToCart: (state, action) => {
      const incomingItem = action.payload;

      const existingItem = state.cart.find(
        v => v.item.id === incomingItem.item.id
      );

      if (existingItem) {
        // increase amount if already exists
        existingItem.amount += incomingItem.amount ?? 1;
      } else {
        // add new item
        state.cart.push({
          ...incomingItem,
          amount: incomingItem.amount ?? 1,
        });
      }
    },

    changeItemAmount: (state, action) => {
      const { currentItemId, currentAmount } = action.payload;

      const item = state.cart.find(v => v.item.id === currentItemId);
      if (item) {
         if (currentAmount <= 0) {
      state.cart = state.cart.filter(
        v => v.item.id !== currentItemId
      );
    } else {
      item.amount = currentAmount;
    }
  
      }
      
    },

    deleteItemFromCart: (state, action) => {
      state.cart = state.cart.filter(
        v => v.item.id !== action.payload
      );
    },

    clearCart: (state) => {
      state.cart = [];
    },

    updateCart: (state, action) => {
      state.cart = action.payload;
    },

    setPageWines: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const {  setCategoryProducts, updateLoadState, updateData, addItemToCart, changeItemAmount, deleteItemFromCart, clearCart, updateCart, 
  setPageWines } = winesSlice.actions;

export default winesSlice.reducer;